<template>
  <div class="wrapper">
    <img :src="content.personalData.profileImg" alt="profile" class="footer-avatar" />
    <div class="container footer">
      <div class="hero-text">
        <h2>{{ content.personalData.contactHeading }}</h2>
        <p>{{ content.personalData.contact }}</p>
        <div class="hero-icons">
          <svg-icon :icon="'email'" />
          <svg-icon :icon="'linkedin'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import content from "../../public/content.json";
import SvgIcon from "./SvgIcon.vue";

export default {
  name: "Footer",
  components: {
    SvgIcon,
  },
  data() {
    return {
      content,
    };
  },
};
</script>

<style lang="scss" scoped>

.wrapper {
  position: relative;
  width: 100%;

  background-color: var(--color-text);
  padding-top: 5rem;
}

.footer-avatar {
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);

  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 5;
}
.footer {
  color: white;
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 10rem 7rem 7rem;
  position: relative;
  z-index: 2;

  .hero-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .hero-icons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 20px;
      margin-top: 0rem;
    }
  }
}
</style>
